import { DictionaryPhrases } from '@sitecore-jss/sitecore-jss-react';
import classnames from 'classnames';
import useDictionary from 'lib/sitecore/use-dictionary';
import {
  ClearRefinementsProps,
  CurrentRefinements,
  CurrentRefinementsProps,
  useClearRefinements,
} from 'react-instantsearch-hooks-web';
import { useSearchDictionary } from '../../../util';

let dicp: DictionaryPhrases;
type ClearFacetsProps = ClearRefinementsProps;

function CustomClearRefinements(props: ClearFacetsProps) {
  const { refine, canRefine } = useClearRefinements(props);
  const dict = useSearchDictionary();
  dicp = useDictionary();
  const transformItems: CurrentRefinementsProps['transformItems'] = (items) => {
    if (dicp) {
      return items.map((item) => ({
        ...item,
        label: dicp[item.attribute] ? dicp[item.attribute] : item.attribute,
      }));
    }

    return items;
  };
  const onClick = () => {
    if (canRefine) {
      refine();
    }
  };

  if (!canRefine) {
    return <></>;
  }
  return (
    <div className={classnames({ hidden: !canRefine })}>
      <h3
        className={classnames('text-blue-night', 'text-base', 'font-medium', 'leading-4', 'mb-4')}
      >
        {dict.announcementFilter}
      </h3>
      <CurrentRefinements className={classnames('flex')} transformItems={transformItems} />
      <div>
        <button
          className={classnames('text-theme-btn-link-text', 'underline', 'leading-4', 'my-4')}
          type="button"
          onClick={onClick}
          disabled={!canRefine}
        >
          {dict.searchFilterClearAll}
        </button>
      </div>
      <hr className={classnames('mb-4', 'border-gray-midGray')} />
    </div>
  );
}

export default CustomClearRefinements;
